import useMetaTag from './useMetaTag'

export default function useMetaDescription(description: string) {
  useMetaTag('description', description, [description])
}
